export function multiSort(fields) {
	// Usage:
	// data.sort(
	// 	multiSort([
	// 		{ key: "brand", order: "asc" },
	// 		{ key: "value", order: "desc" },
	// 	])
	// );
	return (a, b) => {
		for (let { key, order } of fields) {
			const valA = a[key];
			const valB = b[key];

			let result;
			if (typeof valA === "string") {
				result = valA.localeCompare(valB);
			} else {
				result = valA - valB;
			}

			if (result !== 0) {
				return order === "desc" ? -result : result;
			}
		}
		return 0;
	};
}
